import { convertCell } from '@/common/converter/convert-cell'
import { convertCellBigBanner } from '@/common/converter/convert-cell-big-banner'
import { convertCellInstantPlayer } from '@/common/converter/convert-cell-instant-player'

/**
 * convert cell 메서드를 반환
 * 1. big banner 에서 사용하는 셀은 일반 셀이랑 규격이 달라서 분기 처리 됨
 * 2. instant player cell 에서 사용하는 셀은 일반 셀과 규격이 달라서 분기 처리 됨
 * @param cellType
 * @returns {(function({}=): {image: {landscape_large: {background: string, text: string}, portrait: {background: string, text: string}, landscape: {background: string, text: string}}, thumbnail: string, alt: string, event_list: {bodylist: *, url: string}[], brand_taglist: string[], force_refresh: string, title_list: *[], top_taglist})|*|(function({}=): {age_tag: string, thumbnail: string, alt: string, update_taglist: (string[]|*[]), event_list: {bodylist: *, url: string}[], title_list: *[], progress: (*|string), rank: ((function(): *)|string|*), time: string, force_refresh: string, brand_taglist: *[], bottom_taglist: *[], top_taglist: (string[]|*[]), age: (*|string)})}
 */
export const getConvertCell = (cellType = '') => {
  switch (cellType) {
    // big banner (cell)
    case 'banner_text':
      return convertCellBigBanner

    // instant player cell
    case 'band_82':
    case 'band_instantplay_rank':
      return convertCellInstantPlayer

    // default cell (e.g band_14)
    default:
      return convertCell
  }
}
